const CubaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111262)">
      <path
        d="M19.9999 39.9998C31.0456 39.9998 39.9998 31.0456 39.9998 19.9999C39.9998 8.95427 31.0456 0 19.9999 0C8.95427 0 0 8.95427 0 19.9999C0 31.0456 8.95427 39.9998 19.9999 39.9998Z"
        fill="#F0F0F0"
      />
      <path
        d="M20.0004 0C13.4572 0 7.64834 3.14242 3.99951 8H36.0012C32.3524 3.14234 26.5434 0 20.0004 0Z"
        fill="#0052B4"
      />
      <path
        d="M20.0004 39.999C26.5435 39.999 32.3524 36.8566 36.0012 31.999H3.99951C7.64826 36.8567 13.4572 39.999 20.0004 39.999Z"
        fill="#0052B4"
      />
      <path
        d="M0 20C0 21.3699 0.138125 22.7076 0.400547 24H39.5995C39.862 22.7076 40 21.3699 40 20C40 18.6301 39.8619 17.2924 39.5995 16H0.400547C0.138125 17.2924 0 18.6301 0 20Z"
        fill="#0052B4"
      />
      <path
        d="M5.85779 5.85742C-1.9526 13.6678 -1.9526 26.3312 5.85779 34.1417C9.08537 30.9141 12.1894 27.81 19.9999 19.9996L5.85779 5.85742Z"
        fill="#D80027"
      />
      <path
        d="M8.09475 14.7832L9.38959 18.7687H13.5807L10.1903 21.2322L11.4851 25.2178L8.09475 22.7545L4.7042 25.2178L5.99936 21.2322L2.60889 18.7687H6.79967L8.09475 14.7832Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111262">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CubaSvg;
